import React from "react";
import { Stack, Typography } from "@mui/material";

interface LayerCardProps {
  /** Optional — when omitted the header row is not rendered. */
  title?: string;
  description?: string;
  /** Optional element on the right side of header — e.g. "Auto-selected" chip. */
  headerAction?: React.ReactNode;
  children: React.ReactNode;
}

/**
 * White bordered card used for each L-Model layer (L1, L2, L3, Teaching Procedure).
 * The title/description header is optional — useful for nested config cards that
 * carry their own internal heading.
 */
const LayerCard: React.FC<LayerCardProps> = ({ title, description, headerAction, children }) => (
  <Stack
    direction="column"
    gap={5}
    p={6}
    borderRadius={3}
    bgcolor="background.paper"
    sx={{
      border: "1px solid",
      borderColor: (theme) => (theme.palette as any).grayscale?.[100] ?? "#E2E8F0",
    }}
  >
    {(title || headerAction) && (
      <Stack direction="row" alignItems="flex-start" justifyContent="space-between">
        {title && (
          <Stack gap={0}>
            <Typography component="h3" variant="subtitle1">
              {title}
            </Typography>
            {description && (
              <Typography component="p" variant="body2" color="text.secondary">
                {description}
              </Typography>
            )}
          </Stack>
        )}
        {headerAction}
      </Stack>
    )}
    {children}
  </Stack>
);

export default LayerCard;
